import {MeetingRoomAmenitiesByBuilding, RoomActivity} from '@lib/store';
import {TFunction} from 'i18next';
import {constructFilter} from './constructFilter';
import {SECTION_ID_BUILDINGS} from './buildingFilter';

export const SECTION_ID_DYNAMIC_ROOM_ACTIVITY_TYPE = 'SECTION_ID_ROOM_ACTIVITY_TYPE';

export const constructDynamicRoomActivityTypeFilter = <TEntity extends {activities: RoomActivity[]}>(
  meetingRoomAmenitiesByBuilding: MeetingRoomAmenitiesByBuilding,
  t: TFunction,
) => {
  const activitiesWithBuildingId = Object.entries(meetingRoomAmenitiesByBuilding).flatMap(([buildingId, amenities]) => {
    const activities = amenities?.activities ?? [];

    return activities.map((activity) => ({
      id: `${buildingId}_${activity}`,
      label: activity as RoomActivity,
      buildingId,
    }));
  });

  return constructFilter({
    sectionId: SECTION_ID_DYNAMIC_ROOM_ACTIVITY_TYPE,
    sectionTitle: t('meeting:SuitsForTitle'),
    type: 'and',
    data: activitiesWithBuildingId.map(({buildingId, id, label}) => ({
      id,
      label: t(`meetingCharacteristic:${label}`),
      enumValue: label,
      dynamicFilterConfig: {sectionId: SECTION_ID_BUILDINGS, filterOptionId: buildingId},
    })),
    defaultFilterOptions: [],
    predicate: (filter, entity: TEntity) => entity.activities.includes(filter.enumValue),
  });
};
